// Handle creation of new account (inc marketing opt in) + login to existing account
// tslint:disable:max-line-length

import React from "react";
import { actions } from "react-redux-form";

import { RoutesInvoker } from "../../../routesInvoker";
import { ActionPromises } from "../../../state/actionPromises";

import { CreateAccount, LoginAccount } from "./account/forms";

import "./accountForm.scss";

interface Props {
  model: string;
  formState: Forms.EnquiryForm;
  userState: IState<IUser>;
  dispatch: any;
}

export class Account extends React.Component<Props> {
  private toggleHasAccount = () => {
    this.props.dispatch(actions.change(`${this.props.model}.hasAccount`, !this.props.formState.account.hasAccount));

    // Password model is shared between sign in and create, so clear invalidity from failed sign in
    this.props.dispatch(actions.setValidity(`${this.props.model}.password`, { signInFailed: true }));
  }

  public render() {
    const { formState, userState } = this.props;

    const isSignedIn = userState.data != null;
    if (isSignedIn) {
      const countryName = formState.location ? formState.location.name : "";
      return (
        <div className="account-fields-wrap">
          <h3>Hi {userState.data.firstName}, you're already signed in!</h3>
          <p>After sending this enquiry, you'll be able to see your messages and itineraries in your account dashboard, along with messages and itineraries from any other enquiries you've previously made.</p>
          <p><a className="account-state-link" onClick={() => this.props.dispatch(ActionPromises.logout())}>To send this enquiry using a different account, click here.</a></p>
        </div>
      );
    }

    const accountFormProps = {
      model: this.props.model,
      dispatch: this.props.dispatch,
      formState,
      user: this.props.userState.data,
    };

    const canSignIn = formState.account && formState.account.hasAccount;
    if (canSignIn) {
      const resetPasswordLink = `${globalConfig.wwwBaseUrl}${RoutesInvoker.forgottenPassword()}`;
      return (
        <div className="enquiry-form-question account-fields-wrap">
          <p><a className="account-state-link" onClick={this.toggleHasAccount}>First time? Click here to create your TravelLocal account.</a></p>
          <hr />
          <LoginAccount {...accountFormProps} />
          <p><a className="account-state-link" href={resetPasswordLink} target="_blank">Forgotten your password? (Opens in new tab)</a></p>
        </div>
      );
    }
    else {
      return (
        <div className="enquiry-form-question account-fields-wrap">
          <p><a className="account-state-link" onClick={this.toggleHasAccount}>Enquired before? Click here to sign into your TravelLocal account.</a></p>
          <hr />
          <CreateAccount {...accountFormProps} />
        </div>
      );
    }
  }
}
